module.exports = {
  // Language configuration in your Prismic repository: Settings / Translations & locals
  defaultLanguage: "es-co",
  langs: ["es-co", "en-us", "fr-fr"],
}
